import React from "react";
import { createStackNavigator } from "@react-navigation/stack";

import { useTranslation } from "react-i18next";
import InfoPerso from "./InfoPerso";
const Stack = createStackNavigator();

export interface BookingStackProps { }

const InfoPersoStack: React.FC<BookingStackProps> = () => {
  const { t, i18n } = useTranslation();
  return (
    <Stack.Navigator>
      <Stack.Screen
        name="Info"
        component={InfoPerso}
        options={{
          title: t("HEADER_INFO"),
          headerStyle: {
            backgroundColor: "#D71D9A",
          },
          headerTintColor: "#fff",
          headerTitleStyle: {
            fontWeight: "bold",
          },
        }}
      />
    </Stack.Navigator>
  );
};

export default InfoPersoStack;
